export class NoAdhocSessionFound extends Error {
  constructor() {
    super('No adhoc session found')
  }
}

export class UnknownError extends Error {
  constructor(message?: string) {
    super(message ?? 'Unknown error')
  }
}

export const getErrorMessageFromOFetchException = (e: unknown): string => {
  if (typeof e?.data?.message === 'string') {
    return e.data.message
  }
  if (typeof e?.message === 'string') {
    return e.message
  }
  return String(e)
}

export const getHttpStatusCodeFromOFetchException = (e: unknown): number | null => {
  if (typeof e?.statusCode === 'number') {
    return e?.statusCode
  }
  return null
}
